import styled from "styled-components";

export const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 0px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

export const FlexCenter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 15px;
`;

export const SocialIcons = styled.img`
  width: 40px;
  height: 40px;
  margin: 0px 8px;
`;

export const BorderLine = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.3);
  max-width: 1100px;
  margin: -50px auto 0px auto;
`;
